import { rootAxios } from "@/common/api/axios";
import { useQuery } from "@tanstack/react-query";

export const useServerHealthCheck = () => {
  return useQuery({
    refetchInterval: 15000,
    queryKey: ['serverHealthCheck'],
    queryFn: async () => rootAxios.get('/health_check'),
    networkMode: 'always',
    retry: 0,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: true,
    staleTime: Infinity,
  });
};
